// extracted by extract-css-chunks-webpack-plugin
module.exports = {"color-wrapper":"r-S9v","large-wrapper":"Fk6Fc","color-label":"rLSKC","color-pane":"WBQ8E","color-wrapper-active":"iM10q","facet-image":"_0Cyd1","bg-color-multi":"IK0ad"};